<cb-authorized>
    <p>my-company works!</p>
</cb-authorized>

